export default __webpack_public_path__ + "static/treneri-irina-maizlish-6f91711a3657a75bd4c7e3f095d2d433.jpg";